import { months_dictionary } from '../../dictionaries/months_dictionary.js';
import {
  districts_dictionary,
  regions_dictionary,
  regions_districts_id_dictionary,
} from '../../dictionaries/regions_districts_dictionary.js';

const staticData = [
  'Карагандинская область, г.Темиртау, 3.73',
  'Костанайский район, Фёдоровский район, 3.73',
  'Кызылординская область, Кармакшинский район, 3.73',
  'Павлодарская область, г.Аксу, 3.73',
  'Кызылординская область, Жалагашский район, 3.71',
  'Атырауская область, Индерский район, 3.53',
  'Алматинская область, Жамбылский район, 3.49',
  'Костанайская область, Аулиекольский район, 3.40',
  'Туркестанская область, Сайрамский район, 3.40',
  'Алматы, Жетысуский район, 3.36',
  'Мангистауская область, г.Актау, 3.31',
  'Атырауская область, Курмангазинский район, 3.20',
  'Шымкент, Аль-Фарабийский район, 3.17',
  'Туркестанская область, Созакский район, 3.10',
  'Туркестанская область, Толебийский район, 3.08',
  'Мангистауская область, Мунайлинский район, 3.05',
  'Актюбинская область, Мугалжарский район, 3.03',
  'Костанайская область, Карабалыкский район, 3.02',
  'Абайская область, Аксуатский район, 3.02',
  'Туркестанская область, Сарыагашский район, 3.00',
  'Карагандинская область, Бухар-Жырауский район, 2.98',
  'Абайская область, Аягозский район, 2.92',
  'Карагандинская область, г.Балхаш, 2.91',
  'Костанайский район, Узункольский район, 2.80',
  'Мангистауская область, Мангистауский район, 2.80',
  'Жетысуская область, Панфиловский район, 2.76',
  'Актюбинская область, Алгинский район, 2.76',
  'Туркестанская область, г.Туркестан, 2.73',
  'Алматы, Медеуский район, 2.71',
  'Актюбинская область, Хромтауский район, 2.68',
  'Актюбинская область, Мартукский район, 2.67',
  'Костанайский район, г.Лисаковск, 2.62',
  'Алматинская область, г.Алатау, 2.61',
  'Костанайская область, Денисовский район, 2.60',
  'Актюбинская область, г.Актобе, 2.59',
  'Костанайская область, г.Костанай, 2.58',
  'Астана, Сарыаркинский район, 2.56',
  'Алматинская область, Карасайский район, 2.55',
  'Шымкент, Енбекшинский район, 2.54',
  'Астана, Нуринский район, 2.53',
  'Астана, Байконурский район, 2.51',
  'Астана, Есильский район, 2.50',
  'Алматинская область, Енбекшиказахский район, 2.47',
  'Туркестанская область, Тюлькубасский район, 2.43',
  'Абайская область, г.Семей, 2.43',
  'Восточно-Казахстанская область, Алтайский район, 2.43',
  'Абайская область, Бородулихинский район, 2.41',
  'Западно-Казахстанская область, г.Уральск, 2.40',
  'Восточно-Казахстанская область, г.Риддер, 2.40',
  'Карагандинская область, г.Шахтинск, 2.38',
  'Костанайская область, Карасуский район, 2.38',
  'Костанайский район, Мендыкаринский район, 2.38',
  'Астана, Алматинский район, 2.36',
  'Алматы, Алатауский район, 2.33',
  'Жамбылская область, г.Тараз, 2.33',
  'Алматы, Бостандыкский район, 2.31',
  'Северо-Казахстанская область, г.Петропавловск, 2.30',
  'Восточно-Казахстанская область, Катон-Карагайский район, 2.25',
  'Павлодарская область, Актогайский район, 2.23',
  'Акмолинская область, Жаксынский район, 2.23',
  'Абайская область, Жарминский район, 2.21',
  'Акмолинская область, Аккольский район, 2.20',
  'Акмолинская область, Буландынский район, 2.20',
  'Акмолинская область, Бурабайский район, 2.20',
  'Акмолинская область, Есильский район, 2.20',
  'Акмолинская область, Жаркаинский район, 2.20',
  'Акмолинская область, г.Кокшетау, 2.20',
  'Акмолинская область, Сандыктауский район, 2.20',
  'Шымкент, Абайский район, 2.20',
  'Жетысуская область, Алакольский район, 2.18',
  'Акмолинская область, Шортандинский район, 2.18',
  'Акмолинская область, Зерендинский район, 2.17',
  'Восточно-Казахстанская область, Уланский район, 2.17',
  'Алматы, Алмалинский район, 2.16',
  'Улытауская область, г.Жезказган, 2.16',
  'Акмолинская область, Биржан сал район, 2.16',
  'Акмолинская область, Целиноградский район, 2.16',
  'Жетысуская область, г.Талдыкорган, 2.16',
  'Акмолинская область, Астраханский район, 2.16',
  'Акмолинская область, Аршалынский район, 2.13',
  'Алматинская область, Талгарский район, 2.11',
  'Актюбинская область, Каргалинский район, 2.07',
  'Восточно-Казахстанская область, Усть-г.Каменогорск, 2.05',
  'Восточно-Казахстанская область, Шемонаихинский район, 2.05',
  'Улытауская область, Улытауский район, 2.03',
  'Павлодарская область, г.Павлодар, 2.02',
  'Павлодарская область, Щербактинский район, 2.02',
  'Костанайская область, г.Аркалык, 2.00',
  'Павлодарская область, Павлодарский район, 2.00',
  'Алматы, Наурызбайский район, 1.98',
  'Улытауская область, г.Каражал, 1.95',
  'Жетысуская область, Ескельдинский район, 1.93',
  'Костанайская область, Житикаринский район, 1.92',
  'Мангистауская область, Каракиянский район, 1.92',
  'Павлодарская область, Теренкольский район, 1.91',
  'Павлодарская область, Иртышский район, 1.90',
  'Кызылординская область, г.Кызылорда, 1.90',
  'Абайская область, Кокпектинский район, 1.87',
  'Восточно-Казахстанская область, Глубоковский район, 1.87',
  'Восточно-Казахстанская область, Зайсанский район, 1.87',
  'Костанайский район, г.Рудный, 1.87',
  'Алматинская область, г.Конаев, 1.86',
  'Мангистауская область, Тупкараганский район, 1.85',
  'Алматинская область, Балхашский район, 1.78',
  'Восточно-Казахстанская область, Куршимский район, 1.78',
  'Атырауская область, г.Атырау, 1.78',
  'Жамбылская область, Меркенский район, 1.76',
  'Западно-Казахстанская область, Теректинский район, 1.75',
  'Туркестанская область, Ордабасинский район, 1.70',
  'Алматинская область, Илийский район, 1.68',
  'Западно-Казахстанская область, Байтерекский район, 1.67',
  'Западно-Казахстанская область, Бурлинский район, 1.67',
  'Павлодарская область, г.Экибастуз, 1.63',
  'Алматинская область, Уйгурский район, 1.62',
  'Павлодарская область, Железинский район, 1.60',
  'Алматы, Турксибский район, 1.60',
  'Карагандинская область, Нуринский район, 1.53',
  'Акмолинская область, Атбасарский район, 1.51',
  'Абайская область, район Жаңасемей, 1.48',
  'Северо-Казахстанская область, Район имени Габита Мусрепова, 1.37',
  'Карагандинская область, г.Караганда, 1.34',
  'Кызылординская область, Казалинский район, 1.30',
  'Павлодарская область, Успенский район, 1.25',
  'Жамбылская область, Кордайский район, 1.17',
  'Северо-Казахстанская область, Уалихановский район, 1.10',
  'Алматы, Ауэзовский район, 1.04',
  'Северо-Казахстанская область, Аккайынский район, 0.96',
  'Карагандинская область, Осакаровский район, 0.95',
  'Актюбинская область, Айтекебийский район, 0.92',
  'Костанайский район, Сарыкольский район, 0.92',
  'Северо-Казахстанская область, Есильский район, 0.86',
  'Мангистауская область, г.Жанаозен, 0.83',
  'Северо-Казахстанская область, Акжарский район, 0.77',
];
const tempDataSource = {};
staticData
  .map((item) => item.split(', '))
  .forEach((item) => {
    if (!tempDataSource[item[0]]) {
      tempDataSource[item[0]] = {
        [item[1]]: Number(item[2]),
      };
    } else {
      tempDataSource[item[0]][item[1]] = Number(item[2]);
    }
  });

export const prepareDashboardModalData = (data) => {
  const result = [];
  Object.entries(data).forEach(([year, values]) => {
    if (year !== 'None') {
      values
        ?.toSorted((a, b) => a.month - b.month)
        ?.forEach((i) => {
          result.push({
            month: `${months_dictionary[i.month]} ${year}`,
            value: i.value,
            year,
          });
        });
    }
    if (year === 'None') {
      values?.forEach((i) => {
        result.unshift({
          month: `Без даты`,
          value: i.value,
          year,
        });
      });
    }
  });
  return result;
};

export function prepareBizRegionModalData(data, granularity) {
  return Object.entries(data).map(([region_id, districtsData]) => {
    const quarters_avg = {};
    Object.keys(districtsData.values).forEach((year) => {
      Object.keys(districtsData.values[year]).forEach((quarter) => {
        quarters_avg[`${year}_${quarter}`] =
          districtsData.values[year][quarter];
      });
    });
    return {
      id: region_id,
      name: regions_dictionary[region_id],
      // quarters_avg: extractRegionAvg(districtsData, granularity),
      quarters_avg,
    };
  });
}

function extractRegionAvg(districts, granularity = 'quarter') {
  const avgPerQuarter = {};
  const dist_copy = { ...districts };
  delete dist_copy.categories;
  delete dist_copy.values;
  for (const district of Object.values(dist_copy)) {
    for (const quarter of district) {
      if (granularity === 'quarter') {
        if (quarter.quarter) {
          avgPerQuarter[`${quarter.year}_${quarter.quarter}`]
            ? avgPerQuarter[`${quarter.year}_${quarter.quarter}`].push(
                ...Object.values(quarter.categories)
              )
            : (avgPerQuarter[`${quarter.year}_${quarter.quarter}`] =
                Object.values(quarter.categories));
        }
      } else if (granularity === 'year') {
        avgPerQuarter[`${quarter.year}`]
          ? avgPerQuarter[`${quarter.year}`].push(
              ...Object.values(quarter.categories)
            )
          : (avgPerQuarter[`${quarter.year}`] = Object.values(
              quarter.categories
            ));
      }
    }
  }
  for (const [quarter, values] of Object.entries(avgPerQuarter)) {
    avgPerQuarter[quarter] = (
      values.reduce((a, b) => a + b, 0) / values.length
    ).toFixed(2);
  }
  return avgPerQuarter;
}

export function prepareBizDistrictModalData(
  data,
  region,
  granularity,
  quarter,
  year,
  type,
  distDict
) {
  const business_type = type === 'business_inspections' ? 'small' : 'medium';
  const title = regions_dictionary[region];
  const districtsData = {
    ...data[region],
  };
  const distCategoriesValues = {
    categories: districtsData.categories,
    values: districtsData.values,
  };
  if (districtsData.categories) delete districtsData.categories;
  if (districtsData.values) delete districtsData.values;
  const years = Array.from(
    new Set(Object.values(districtsData).flatMap((i) => i.map((j) => j.year)))
  );
  const table = [];
  const charts = { column: [], bar: [] };
  charts.column = Object.entries(extractRegionAvg(districtsData)).map(
    ([q, avg]) => ({
      quarter: `${q.split('_')[1]} кв. ${q.split('_')[0]}`,
      value: +avg,
    })
  );
  if (granularity === 'quarter') {
    const quartersAll = Object.values(districtsData).flatMap((i) =>
      i.filter((q) => q.year === year && q.quarter === quarter)
    );
    const perCategories = extractQuarterStatsPerCatAvg(quartersAll);
    // charts.bar = Object.entries(perCategories).map(([category, avg]) => ({
    //   category,
    //   value: +avg,
    // }));
    if (
      distCategoriesValues.categories[year] &&
      distCategoriesValues.categories[year][quarter]
    ) {
      charts.bar = Object.keys(
        distCategoriesValues.categories[year][quarter]
      ).map((key) => {
        return {
          category: key,
          value: distCategoriesValues.categories[year][quarter][key],
        };
      });
    } else {
      charts.bar = [];
    }
  }

  for (const [district_id, quarters] of Object.entries(districtsData)) {
    if (granularity === 'quarter') {
      let perCategories = districtsData[district_id].find(
        (item) => item.quarter === quarter && item.year === year
      )?.categories;
      if (!perCategories) perCategories = {};
      table.push({
        id: district_id,
        name: distDict[district_id],
        avg:
          Object.values(perCategories).reduce((a, b) => a + Number(b), 0) /
          Object.values(perCategories).length,
        categories: perCategories,
      });
    } else {
      const searchYear = Number(year);

      const perCategories =
        districtsData[district_id]?.find((i) => i.year === searchYear)
          ?.categories ?? {};
      // const perCategories =
      //   districtsData[district_id]?.find((i) => i.year === year)?.categories ??
      //   {};
      charts.bar = Object.entries(
        distCategoriesValues.categories[year].None
      ).map(([category, avg]) => ({
        category,
        value: +avg,
      }));
      const values = Object.values(perCategories);
      const avg =
        values.length > 0
          ? values.reduce((a, b) => a + Number(b), 0) / values.length
          : 0;
      if (Object.keys(perCategories)?.length > 0) {
        table.push({
          id: district_id,
          name: distDict[district_id],
          avg,
          categories: perCategories,
        });
      }

      // let avg =
      //   Object.values(perCategories).reduce((a, b) => a + Number(b), 0) /
      //   Object.values(perCategories).length;
      // if (business_type === 'medium') {
      //   avg = tempDataSource[regions_dictionary[region]][distDict[district_id]];
      // }
      // table.push({
      //   id: district_id,
      //   name: distDict[district_id],
      //   avg,
      //   categories: perCategories,
      // });
    }
  }
  return { title, table, years, charts };
}

function extractQuarterStatsPerCatAvg(quarters) {
  const perCat = {};
  for (const quarter of quarters) {
    for (const [category, value] of Object.entries(quarter.categories)) {
      perCat[category]
        ? perCat[category].push(value)
        : (perCat[category] = [value]);
    }
  }
  for (const [category, values] of Object.entries(perCat)) {
    perCat[category] = (
      values.reduce((a, b) => a + b, 0) / values.length
    ).toFixed(2);
  }
  return perCat;
}

export function transformYearPollData(data) {
  if (!data) return [];

  return data.map((questionItem) => {
    return {
      label: questionItem.question,
      chart_data: processSingleQuestion(questionItem),
    };
  });
}

function processSingleQuestion(data) {
  const { options: globalOptions, total_count: globalTotal, detail } = data;

  // Iterate over each answer option available for this question
  return Object.entries(globalOptions).map(([answerKey, answerCount]) => {
    // 1. Calculate Global Percentage (First Modal)
    // Avoid division by zero
    const globalPercentage =
      globalTotal > 0 ? (answerCount / globalTotal) * 100 : 0;

    // 2. Process Details for this specific Answer Option (Second Modal)
    const groupedDetails = {};
    const NULL_AGENCY_KEY = '__NULL__';

    detail.forEach((detailItem) => {
      // Check if this specific department actually has data for the current answerKey
      const localCount = detailItem.options[answerKey] ?? 0;

      const agencyKey = detailItem.agency ?? NULL_AGENCY_KEY;

      if (!groupedDetails[agencyKey]) {
        groupedDetails[agencyKey] = [];
      }

      // Calculate Local Percentage
      // Use the detail item's OWN total_count as the denominator
      const localPercentage =
        detailItem.total_count > 0
          ? (localCount / detailItem.total_count) * 100
          : 0;

      groupedDetails[agencyKey].push({
        group: detailItem.group,
        percentage: Number(localPercentage.toFixed(2)),
      });
    });

    // 3. Format the grouped storage into Arrays
    const formattedDetails = Object.keys(groupedDetails).map((key) => ({
      agency: key === NULL_AGENCY_KEY ? null : key,
      data: groupedDetails[key],
    }));

    return {
      answer_option: answerKey,
      percentage: Number(globalPercentage.toFixed(2)),
      details: formattedDetails,
    };
  });
}
